export default __webpack_public_path__ + "static/media/Candidaturas-locales.df80cb94.png";